import * as types from './types';

const defaultTab = 'description';

export const state = {
  activeTab: defaultTab,
};

export const mutations = {
  [types.SET_ACTIVE_TAB](state, slug) {
    state.activeTab = slug;
  },
  [types.RESET_ACTIVE_TAB](state) {
    state.activeTab = defaultTab;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Downloads/store/mutations.js